import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import Feature from '../Feature';

import ResponseRateIcon from './ResponseRateIcon';

import styles from './ResponseRateFeature.module.scss';

const RESPONSE_RATE_FEATURE = 'responseRateFeature';

const STATE_CONFIG = {
  4: { bodyKey: 'property_show.book_now_card.response_rate.high.body' },
  3: { bodyKey: 'property_show.book_now_card.response_rate.medium.body' },
  2: { bodyKey: 'property_show.book_now_card.response_rate.low.body' }
};

const ResponseRateFeature = ({
  responseRateState,
  responseRatePercentage,
  collapsed = true,
  onCollapsedChange = () => {}
}) => {
  const config = STATE_CONFIG[responseRateState];
  if (!config) return null;

  return (
    <Feature
      featureName={RESPONSE_RATE_FEATURE}
      collapsed={collapsed}
      onCollapsedChange={onCollapsedChange}
      renderIcon={() => <ResponseRateIcon state={responseRateState} />}
      headerKey="property_show.book_now_card.response_rate.title"
      renderBody={() => (
        <div className={styles['response-rate-body']}>
          <p className={styles['response-rate-body__description']}>
            {trans(config.bodyKey)}
          </p>
          <p className={styles['response-rate-body__description']}>
            {trans('property_show.book_now_card.response_rate.percentage', {
              percentage: responseRatePercentage ?? ''
            })}
          </p>
        </div>
      )}
    />
  );
};

ResponseRateFeature.propTypes = {
  responseRateState: PropTypes.oneOf([2, 3, 4]).isRequired,
  responseRatePercentage: PropTypes.number,
  collapsed: PropTypes.bool,
  onCollapsedChange: PropTypes.func
};

export default ResponseRateFeature;
